import { entity, list } from "./base";
import { concatModules } from "@/utility";
import utility from "@/utility";

const initialEntity = {
};

const name = "masters";

const setOptionRefreshTrigger = (name, store) => {
  if (store.state[name].options) {
    store.commit(`${name}/options/setRefreshTrigger`, {
      root: true
    });
  }
};

const masterEntityModule = {
  state: {
    open: false,
    pk: null
  },
  mutations: {
    open(state, { pk }) {
      state.open = true;
      state.pk = pk;
    },
    close(state) {
      state.open = false;
      state.pk = null;
    }
  },
  actions: {
  },
  getters: {
    open(state) {
      return state.open;
    },
    pk(state) {
      return state.pk;
    }
  }
};

const masterListModule = {
  state: {
    mainFlgOpen: false,
    groups: [],
    keywords: [],
    mainFlgProcessing: false
  },
  mutations: {
    mainFlgOpen(state) {
      state.mainFlgOpen = true;
    },
    mainFlgClose(state) {
      state.mainFlgOpen = false;
    },
    setGroups(state, payload) {
      state.groups = payload.groups
    },
    setKeywords(state, payload) {
      state.keywords = payload.keywords
    },
    resetKeywords(state) {
      state.keywords = [];
    },
    mainFlgProcessing(state) {
      state.mainFlgProcessing = true;
    },
    mainFlgProcessed(state) {
      state.mainFlgProcessing = false;
    }
  },
  actions: {
    enable({ commit }, { ids }) {
      const store = this;

      commit("processing");

      return new Promise((resolve, reject) => {
        store.$axios
          .put(`/${name}/status/enable`, {
            ids
          })
          .then(() => {
            commit("processed");
            setOptionRefreshTrigger(name, store);

            utility.$message({
              type: "success",
              message: "更新しました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", { error });
            reject(error);
          });
      });
    },
    disable({ commit }, { ids }) {
      const store = this;

      commit("processing");

      return new Promise((resolve, reject) => {
        store.$axios
          .put(`/${name}/status/disable`, {
            ids
          })
          .then(() => {
            commit("processed");
            setOptionRefreshTrigger(name, store);

            utility.$message({
              type: "success",
              message: "更新しました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", { error });
            reject(error);
          });
      });
    },
    groups({ commit, getters }) {
      commit("mainFlgProcessing");
      return new Promise((resolve, reject) => {
        this.$axios
          .get(`/options/master_groups`)
          .then((response) => {
            commit("mainFlgProcessed");
            commit("setGroups", {
              groups: response.data.data
            });
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    keywords({ commit, getters }, { group }) {
      commit("mainFlgProcessing");
      return new Promise((resolve, reject) => {
        this.$axios
          .get(`/options/master_keywords`, {
            params: {
              group: group
            }
          })
          .then((response) => {
            commit("mainFlgProcessed");
            commit("setKeywords", {
              keywords: response.data.data
            });
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    updateMainFlg({ commit }, { updatedEntity }) {
      const store = this;

      commit("mainFlgProcessing");

      return new Promise((resolve, reject) => {
        store.$axios
          .put(`/${name}/mainflg/update`, updatedEntity)
          .then(() => {
            commit("mainFlgProcessed");

            utility.$message({
              type: "success",
              message: "更新しました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("mainFlgProcessed");
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {
    mainFlgOpen(state) {
      return state.mainFlgOpen;
    },
    mainFlgProcessing(state) {
      return state.mainFlgProcessing;
    },
    groups(state) {
      return state.groups;
    },
    keywords(state) {
      return state.keywords
    }
  }
};

const entityModule = entity(name, initialEntity);
const listModule = list(name);

export const masters = {
  namespaced: true,
  modules: {
    list: concatModules(listModule, masterListModule),
    entity: concatModules(entityModule, masterEntityModule),
  }
};
